<template>
  <svg
    width="45"
    height="36"
    viewBox="0 0 45 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_389_14684)">
      <path
        d="M29.8477 35.4999C29.016 34.2794 28.2776 33.1954 27.5155 32.0777C31.266 29.9321 34.4869 27.2711 36.4522 23.298C37.3077 21.5667 37.8421 19.7424 38.0982 17.7382C36.8222 18.3886 35.5415 18.6054 34.2022 18.5604C29.6722 18.4111 26.1541 15.4208 25.3525 11.0221C24.2725 5.07849 29.3702 -0.269316 35.2442 0.591471C39.4312 1.20494 42.0369 3.79694 43.6402 7.52916C45.4475 11.7383 45.3495 16.0856 43.9565 20.3864C42.252 25.6539 38.8461 29.6286 34.4062 32.7232C32.9658 33.727 31.4083 34.5556 29.8477 35.4999Z"
        fill="#6D7492"
      />
      <path
        d="M4.53149 35.4213C3.75197 34.2763 3.01673 33.1938 2.25302 32.0745C7.87091 28.8979 11.9076 24.5667 12.8294 17.8715C11.9898 18.0883 11.1787 18.4063 10.3423 18.4946C4.59631 19.1001 -0.0728718 14.8491 -0.000138186 9.58001C0.0899883 3.23331 5.52446 -1.31313 12.3282 1.21463C15.5949 2.42873 17.5097 5.04803 18.645 8.20532C20.3874 13.0472 19.9653 17.8667 17.8686 22.5175C15.5048 27.7593 11.5582 31.4948 6.68029 34.2923C5.99565 34.6842 5.28412 35.0278 4.53149 35.4229V35.4213Z"
        fill="#6D7492"
      />
    </g>
    <defs>
      <clipPath id="clip0_389_14684">
        <rect
          width="45"
          height="35"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
  
<script>
export default {
  name: "QuotesIcon",
};
</script>